import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiClock, FiMapPin, FiMessageCircle, FiLayers } = FiIcons;

const benefits = [
  [FiClock, 'Ahorra tiempo', 'Mientras nosotros hacemos el mandao, tú puedes seguir con tu día.'],
  [FiMapPin, 'Servicio local', 'Operamos en Bonao y conocemos nuestra ciudad.'],
  [FiMessageCircle, 'Atención directa', 'Comunícate fácilmente con nosotros para solicitar tu servicio.'],
  [FiLayers, 'Diferentes mandaos', 'Comida, compras, documentos, paquetes y mucho más.']
];

function Benefits() {
  return (
    <section className="benefits section">
      <div className="container">
        <div className="section-heading section-heading--center">
          <span className="eyebrow">Tu tiempo vale</span>
          <h2>Resolvemos <em>por ti.</em></h2>
        </div>
        <div className="benefits__grid">
          {benefits.map(([icon, title, text], index) => (
            <motion.article
              className="benefit-card"
              key={title}
              whileHover={{ y: -6 }}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.06 }}
            >
              <span><SafeIcon icon={icon} /></span>
              <h3>{title}</h3>
              <p>{text}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Benefits;